const paramsRex = /\{\{(.*?)\}\}/g;


export default (template, data) => template.replace(
  paramsRex, expression => expression.slice(2,-2).chain(
    name => {
      let value = data[name] !== undefined ? data[name] : expression;
      return typeof value == "number" ? value.toLocaleString() : value;
    }
  )
);



// WEBPACK FOOTER //
// ./utils/template_render.js